import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import './prototype'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import App from './App';
import * as serviceWorker from './serviceWorker';

import store from './store'
import './classes/storage.class.js';

import { icons } from './assets/icons'

const stagingMap = {
  'http://localhost:9000': 'localhost',
  'https://staging.api.x-guard.nl': 'staging',
};

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <App/>
    {process.env.REACT_APP_API_BASE_URL !== 'https://billing.api.x-guard.nl' ?
    <div className="env-warning">Connected to {stagingMap[process.env.REACT_APP_API_BASE_URL] || process.env.REACT_APP_API_BASE_URL || 'localhost'}</div>
    : null }
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
